import { useDisclosure, useRouteMatchParam } from '@/hooks';
import { Button, Col, Form, Modal, Row, Space, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import CompanyInvoiceCFeCreateModal from './InvoiceCFeCreateModal';
import { useState } from 'react';
import {
  useCouponEquipamentList,
  useCouponEquipamentRemove,
} from '@/core/domain/coupon/company/company.hooks';
import { CouponEquipment } from '@/core/domain/coupon/company/company.types';
import { DeleteIcon, EditIcon } from '@/components/_common';

const CompanyCouponEquipments: React.FC = () => {
  const companyId = useRouteMatchParam('companyId');
  const [equipment, setEquipament] = useState<CouponEquipment>();

  const [modalOpened, modalAction] = useDisclosure(false, {
    onClose: () => setEquipament(undefined),
  });

  const couponEquipaments = useCouponEquipamentList(Number(companyId));
  const couponEquipamentRemove = useCouponEquipamentRemove();

  function confirmRemoveEquipment(couponEquipment: CouponEquipment) {
    Modal.confirm({
      title: 'Remover equipamento',
      content: `Deseja remover o equipamento "${couponEquipment.connectionNumber}"?`,
      onOk: async () =>
        await couponEquipamentRemove.mutateAsync({
          equipmentId: couponEquipment.id,
          companyId: Number(companyId),
        }),
      okType: 'danger',
      okText: 'Remover',
    });
  }

  function editEquipment(couponEquipment: CouponEquipment) {
    setEquipament(couponEquipment);
    modalAction.open();
  }

  const columns: ColumnsType<CouponEquipment> = [
    { dataIndex: 'version', title: 'Versão', width: 200, ellipsis: true },
    {
      dataIndex: 'connectionNumber',
      title: 'Cód. da Caixa',
      width: 200,
      ellipsis: true,
    },
    {
      dataIndex: 'serialNumber',
      title: 'Cód. de Série',
      width: 200,
      ellipsis: true,
    },
    {
      dataIndex: 'activationCode',
      title: 'Cód. de ativação',
      width: 200,
      ellipsis: true,
    },
    {
      dataIndex: 'signature',
      title: 'Chave de assinatura',
      width: 200,
      ellipsis: true,
      render: (value: string) => `${value.slice(0, 50)}...`,
    },
    {
      title: 'Ação',
      width: 72,
      align: 'center',
      fixed: 'right',
      render: (_, row) => (
        <Space size="large">
          <EditIcon iconProps={{ onClick: () => editEquipment(row) }} />
          <DeleteIcon onClick={() => confirmRemoveEquipment(row)} />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Form.Item name={['cfe', 'id']} hidden />

      <Row justify="space-between" gutter={[16, 16]}>
        <Col flex={1}>
          <Typography.Title level={4}>
            Equipamentos SAT (Ponto de caixa)
          </Typography.Title>
        </Col>

        <Col>
          <Button onClick={modalAction.open} type="primary">
            Cadastrar equipamento
          </Button>
        </Col>
      </Row>

      <div style={{ minHeight: 200, marginTop: 24 }}>
        <Table
          dataSource={couponEquipaments.data}
          columns={columns}
          pagination={false}
          scroll={{ x: true }}
        />
      </div>

      <CompanyInvoiceCFeCreateModal
        open={modalOpened}
        onCancel={modalAction.close}
        equipment={equipment}
      />
    </>
  );
};

export default CompanyCouponEquipments;
